import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  section: {
    marginBottom: 30
  },
  tableCell: {
    display: 'flex',
    alignContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle'
  },
  centreDiv: {
    display: 'flex',
    alignContent: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  checkCircle: {
    color: 'green',
    fontSize: 25
  },
  cancelCircle: {
    color: 'red',
    fontSize: 25
  },
  passwordLine: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  buttonColor: {
    marginTop: 10,
    backgroundColor: '#3494b6',
    '&:hover': {
      backgroundColor: '#23647b'
    }
  }
}))
